import { render, staticRenderFns } from "./EditCustomerPage.vue?vue&type=template&id=7d9a5076"
import script from "./EditCustomerPage.vue?vue&type=script&lang=js"
export * from "./EditCustomerPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports